var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { monteurApi } from '../common/monteur-api';
export var techniciansApi = monteurApi
    .enhanceEndpoints({
    addTagTypes: ['Technicians', 'Technician', 'MatchingTechnicians']
})
    .injectEndpoints({
    endpoints: function (builder) { return ({
        getPaginatedTechnicians: builder.query({
            query: function (technician) { return ({
                url: "Technician/get-paginated",
                method: 'POST',
                body: technician
            }); },
            providesTags: ['Technicians']
        }),
        updateTechnicianStatus: builder.mutation({
            query: function (command) { return ({
                url: 'Technician/update-status',
                method: 'POST',
                body: command
            }); },
            invalidatesTags: ['Technicians', 'Users']
        }),
        getTechnician: builder.query({
            keepUnusedDataFor: 0,
            query: function (id) { return ({
                url: "Technician/get-by-id?id=".concat(id),
                method: 'GET'
            }); },
            providesTags: ['Technician']
        }),
        addTechnicianMachines: builder.mutation({
            query: function (machines) { return ({
                url: 'Technician/add-machines',
                method: 'POST',
                body: machines
            }); },
            onQueryStarted: function (arg_1, _a) {
                return __awaiter(this, arguments, void 0, function (arg, _b) {
                    var result_1, _c;
                    var queryFulfilled = _b.queryFulfilled, dispatch = _b.dispatch;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                result_1 = _d.sent();
                                dispatch(techniciansApi.util.updateQueryData('getTechnician', arg.technicianId, function (technician) {
                                    technician.technicianMachines = result_1.data;
                                }));
                                return [3 /*break*/, 3];
                            case 2:
                                _c = _d.sent();
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            }
        }),
        updateTechnicianMachines: builder.mutation({
            query: function (machines) { return ({
                url: 'Technician/update-machines',
                method: 'POST',
                body: machines
            }); },
            onQueryStarted: function (arg_1, _a) {
                return __awaiter(this, arguments, void 0, function (arg, _b) {
                    var result_2, _c;
                    var queryFulfilled = _b.queryFulfilled, dispatch = _b.dispatch;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                result_2 = _d.sent();
                                dispatch(techniciansApi.util.updateQueryData('getTechnician', arg.technicianId, function (technician) {
                                    technician.technicianMachines = result_2.data;
                                }));
                                return [3 /*break*/, 3];
                            case 2:
                                _c = _d.sent();
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            }
        }),
        addTechnicianSpecialities: builder.mutation({
            query: function (specialities) { return ({
                url: 'Technician/add-specialities',
                method: 'POST',
                body: specialities
            }); },
            onQueryStarted: function (arg_1, _a) {
                return __awaiter(this, arguments, void 0, function (arg, _b) {
                    var result_3, _c;
                    var queryFulfilled = _b.queryFulfilled, dispatch = _b.dispatch;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                result_3 = _d.sent();
                                dispatch(techniciansApi.util.updateQueryData('getTechnician', arg.technicianId, function (technician) {
                                    technician.technicianSpecialities = result_3.data;
                                }));
                                return [3 /*break*/, 3];
                            case 2:
                                _c = _d.sent();
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            }
        }),
        updateTechnicianSpecialities: builder.mutation({
            query: function (specialities) { return ({
                url: 'Technician/update-specialities',
                method: 'POST',
                body: specialities
            }); },
            onQueryStarted: function (arg_1, _a) {
                return __awaiter(this, arguments, void 0, function (arg, _b) {
                    var result_4, _c;
                    var queryFulfilled = _b.queryFulfilled, dispatch = _b.dispatch;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                result_4 = _d.sent();
                                dispatch(techniciansApi.util.updateQueryData('getTechnician', arg.technicianId, function (technician) {
                                    technician.technicianSpecialities = result_4.data;
                                }));
                                return [3 /*break*/, 3];
                            case 2:
                                _c = _d.sent();
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            }
        }),
        updateTechnicianLevel: builder.mutation({
            query: function (command) { return ({
                url: 'Technician/update-level',
                method: 'POST',
                body: command
            }); },
            invalidatesTags: ['Technicians', 'Technician']
        }),
        getMatchingTechnicians: builder.query({
            keepUnusedDataFor: 0,
            query: function (query) { return ({
                url: "Technician/get-matching-technicians",
                method: 'POST',
                body: query
            }); },
            providesTags: ['MatchingTechnicians']
        })
    }); }
});
export var useGetPaginatedTechniciansQuery = techniciansApi.useGetPaginatedTechniciansQuery, useUpdateTechnicianStatusMutation = techniciansApi.useUpdateTechnicianStatusMutation, useGetTechnicianQuery = techniciansApi.useGetTechnicianQuery, useUpdateTechnicianMachinesMutation = techniciansApi.useUpdateTechnicianMachinesMutation, useAddTechnicianMachinesMutation = techniciansApi.useAddTechnicianMachinesMutation, useUpdateTechnicianSpecialitiesMutation = techniciansApi.useUpdateTechnicianSpecialitiesMutation, useAddTechnicianSpecialitiesMutation = techniciansApi.useAddTechnicianSpecialitiesMutation, useUpdateTechnicianLevelMutation = techniciansApi.useUpdateTechnicianLevelMutation, useLazyGetMatchingTechniciansQuery = techniciansApi.useLazyGetMatchingTechniciansQuery;
